function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCompass = function SvgCompass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E05B49"
    },
    cx: 192,
    cy: 192,
    r: 192
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M381.034,225.46L269.782,114.208c-42.964-42.964-112.6-42.964-155.563,0 c-42.964,42.964-42.964,112.599,0,155.564l111.259,111.259C304.675,367.097,367.107,304.66,381.034,225.46z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 192,
    cy: 192,
    r: 110
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 192,
    cy: 192,
    r: 87.264
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M192,111.344c36.692,0,68.299,21.697,82.746,52.95c-11.584-34.608-44.24-59.558-82.746-59.558 c-38.507,0-71.165,24.951-82.748,59.56C123.699,133.042,155.306,111.344,192,111.344z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "192,177.972 192,177.972 125.817,192 192,206.028 192,206.028 258.183,192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "206.028,192 206.028,192 192,125.817 177.972,192 177.972,192 192,258.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "198.075,185.925 198.075,185.925 163.34,163.34 185.925,198.075 185.925,198.075  220.66,220.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "198.075,198.075 198.075,198.075 220.66,163.34 185.926,185.926 185.926,185.926  163.34,220.66  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27A2DB"
    },
    points: "181.122,181.123 181.122,181.123 140.68,243.32 192,192 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E56353"
    },
    points: "243.32,140.681 181.122,181.123 192,192 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2D93BA"
    },
    points: "192,192 140.68,243.32 202.877,202.878 202.878,202.878 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D15241"
    },
    points: "202.878,202.878 243.32,140.681 192,192 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EBF0F3"
    },
    cx: 192,
    cy: 192.001,
    rx: 12.08,
    ry: 12.08
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E6E9"
    },
    d: "M199.492,186.689c1.506,3.382,0.896,7.476-1.879,10.251c-3.596,3.596-9.426,3.596-13.022,0 c-0.374-0.374-0.685-0.783-0.981-1.2c0.447,1.002,1.057,1.95,1.878,2.772c3.596,3.596,9.426,3.596,13.022,0 C201.733,195.289,202.044,190.284,199.492,186.689z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compass.1e8239f0.svg";
export { ForwardRef as ReactComponent };